import { userInfoSync } from 'hub-http/userInfo';
import { ValueOf } from '../types/common';

export const Gates = {} as const;

export const isUngated = (gateName: ValueOf<typeof Gates>) => {
  try {
    const auth = userInfoSync();
    return auth.gates.includes(gateName);
  } catch (e) {
    return false;
  }
};

export const hasScopes = (...scopes: string[]) => {
  try {
    const auth = userInfoSync();
    return scopes.every((scope) => auth.user.scopes.includes(scope));
  } catch (e) {
    return false;
  }
};

export const hasMarketingVideoScope = () => hasScopes('marketing-video');
